module.exports = __webpack_public_path__ + "img/130.28a3eeb5.gif";